/**
 * Dashboard-card variant context.
 *
 * Lets a container opt every BasicDashboardCard beneath it into the flat
 * "rail" treatment (unified sidebar section: no border, neutral overline
 * header, status shown as an inline dot) without each card threading a prop.
 * The default 'card' value preserves the standalone card chrome everywhere
 * else.
 */
import { createContext } from 'react';

export const DASHBOARD_CARD_VARIANT = {
  CARD: 'card',
  RAIL: 'rail',
};

const DashboardCardVariantContext = createContext(DASHBOARD_CARD_VARIANT.CARD);

export default DashboardCardVariantContext;
